/**
 * Created by jax.luo on 2016/10/27.
 */
angular.module('dpw.components')
    .component('dpwParametersGrid', {
        templateUrl: 'dpw-parameters-grid.html',
        controller: ['$scope', function ($scope) {
        }],
        bindings: {
            columns: '<',
            list: '<',
            handleEdit: '<',
            handleDelete: '<',
            deleteDisabled: '<'
        }
    });